<template>
  <main class="home">
    <div class="title lundi no-select">
      LUNDI PISCINE
    </div>
    <div class="grid g-6 b-rw">
      <div
        v-for="(item, index) in home"
        :key="index"
        class="item b-b b-r"
        :class="item.width + ' ' + item.type"
      >
        <template v-if="item.type == 'image'">
          <router-link
            v-if="item.pagelink"
            :to="{ path: '/' + item.pagelink.parent + '/' + item.pagelink.uid }"
          >
            <img v-lazy="item.image.url" :src="item.image.thumb" alt="" />
          </router-link>
          <img v-else v-lazy="item.image.url" :src="item.image.thumb" alt="" />
        </template>
        <template v-if="item.type == 'video'">
          <video
            v-if="item.video"
            :src="item.video.url"
            playsinline
            autoplay
            muted
            loop
          ></video>
        </template>
        <template v-if="item.type == 'marquee'">
          <div class="marquee lundi">
            <div class="marquee-inner">
              <div class="marquee-text">{{ item.marquee }}</div>
              <div class="marquee-text">{{ item.marquee }}</div>
              <div class="marquee-text">{{ item.marquee }}</div>
              <div class="marquee-text">{{ item.marquee }}</div>
              <div class="marquee-text">{{ item.marquee }}</div>
              <div class="marquee-text">{{ item.marquee }}</div>
              <div class="marquee-text">{{ item.marquee }}</div>
              <div class="marquee-text">{{ item.marquee }}</div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  data() {
    return {
      videoCount: 0,
      videoLength: null
    };
  },
  created() {
    if (this.$store.state.home.length === 0) {
      this.$store.dispatch("loadHome");
    }
  },
  computed: {
    home() {
      return this.$store.state.home;
    }
  }
};
</script>

<style lang="scss">
.title {
  position: fixed;
  left: 50%;
  top: 50%;
  font-size: calc(8 * 1vw);
  line-height: 1;
  letter-spacing: 0.3vw;
  transform: translate(-50%, -50%);
  white-space: nowrap;
  color: var(--orange);
  mix-blend-mode: difference;
  z-index: 3;
  pointer-events: none;
}
.item {
  overflow: hidden;
}
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}
video {
  width: 101%;
  height: 110%;
  object-fit: cover;
  display: block;
}
.marquee {
  display: block;
  background: var(--orange);
  width: 100%;
  height: calc(2 * var(--lh));
  overflow: hidden;
  position: relative;
  color: white;
  box-sizing: border-box;
  .marquee-inner {
    position: absolute;
    box-sizing: border-box;
    top: 0;
    left: 0;
    transform: translateX(0);
    animation: marquee 10s infinite linear;
    white-space: nowrap;
    .marquee-text {
      box-sizing: border-box;
      display: inline-block;
      padding: calc(0.5 * var(--lh)) calc(4 * var(--lh));
    }
  }
}
@keyframes marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-12.5%);
  }
}
</style>
